<template>
  <!-- لیست کشویی فیلتر اسناد -->
  <div class="divFilter" v-bind:style="setLocationShow()">
    <div class="row py-2">
      <div class="col p-1 text-right form-check d-flex align-items-center">
        <input class="form-check-input" type="radio" value="Year" v-model="radioYear" name="flexRadioDefault" id="radioYear"/>
        <label class="form-check-label mr-3 pt-1" for="radioYear"> جستجو در سال {{getYearActive}} </label>
      </div>
      <div class="col p-1 text-right form-check d-flex align-items-center">
        <input class="form-check-input" type="radio" value="AllYear" v-model="radioYear" name="flexRadioDefault" id="radioAllYear"/>
        <label class="form-check-label mr-3 pt-1" for="radioAllYear"> جستجو در تمام سال ها </label>
      </div>
    </div>
    <div class="row">
      <div class="col p-1 text-right">
        <label class="mb-1 text-info">از تاریخ ...</label>
        <date-picker
          color="#7E489C"
          input-class="form-control form-control-sm rounded-0"
          display-format="jYYYY/jMM/jDD"
          v-model="FilterDateStart"
          v-bind:max="FilterDateEnd"
        ></date-picker>
      </div>
      <div class="col p-1 text-right">
        <label class="mb-1 text-info">تا تاریخ ...</label>
        <date-picker
          color="#7E489C"
          input-class="form-control form-control-sm rounded-0"
          display-format="jYYYY/jMM/jDD"
          v-model="FilterDateEnd"
          v-bind:min="FilterDateStart"
        ></date-picker>
      </div>
    </div>
    <div class="row">
      <div class="col p-1 text-right">
        <label class="mb-1 text-info">از شماره ...</label>
        <input
          type="number"
          class="form-control form-control-sm"
          placeholder="از شماره ..."
          v-model="FilterDocNumStart"
        />
      </div>
      <div class="col p-1 text-right">
        <label class="mb-1 text-info">تا شماره ...</label>
        <input
          type="number"
          class="form-control form-control-sm"
          placeholder="تا شماره ..."
          v-model="FilterDocNumEnd"
        />
      </div>
    </div>
    <div class="row">
      <div class="col p-1 text-right">
        <label class="mb-1 text-info">از مبلغ ...</label>
        <input
          type="number"
          class="form-control form-control-sm"
          placeholder="از مبلغ ..."
          v-model="FilterAmountStart"
        />
      </div>
      <div class="col p-1 text-right">
        <label class="mb-1 text-info">تا مبلغ ...</label>
        <input
          type="number"
          class="form-control form-control-sm"
          placeholder="تا مبلغ ..."
          v-model="FilterAmountEnd"
        />
      </div>
    </div>
    <div class="row">
      <div class="col p-1 text-right">
        <label class="mb-1 text-info">نوع سند</label>
        <select
          id="selectNPerType"
          class="form-control form-control-sm text-center selectStyle"
          v-model="FilterNAccType"
        >
          <option
            v-for="option in getTbBaseDocTypeData"
            v-bind:key="option.NCode"
            v-bind:value="option.NCode"
          >
            {{ option.SDesc }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col p-1 text-right">
        <label class="mb-1 text-info">سازمان</label>
        <select
          id="selectNPerType"
          class="form-control form-control-sm text-center selectStyle"
          v-model="FilterBaseOrg"
        >
          <option
            v-for="option in getTbBaseOrgData"
            v-bind:key="option.NCode"
            v-bind:value="option.NCode"
          >
            {{ option.SDesc }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col p-1 text-right">
        <label class="mb-1 text-info">جستجوی پیشرفته در محتویات اسناد</label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="جستجوی پیشرفته در محتویات اسناد"
          v-model="FilterSearch"
        />
      </div>
    </div>
    
    <div class="row justify-content-end">
      <div class="col-3 offset-3 p-1">
        <a
          class="
            btn btn-warning btn-sm btn-floating
            m-0
            d-flex
            justify-content-around
            align-items-center
          "
          style="height: 30px"
          title="لغو پالایش ها"
          v-on:click="cancelFilter"
        >
          <i class="fas fa-eraser fa-1x-half text-white px-2"></i>
          لغو
        </a>
      </div>
      <div class="col-6 p-1">
        <a
          class="
            btn btn-info btn-sm btn-floating
            m-0
            d-flex
            justify-content-around
            align-items-center
          "
          style="height: 30px"
          title="پالایش لیست اسناد"
          v-on:click="filterListAcc"
        >
          <i class="fas fa-filter fa-1x-half text-white px-2"></i>
          اعمال فیلتر
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      FilterDateStart: "",
      FilterDateEnd: "",
      FilterDocNumStart: "",
      FilterDocNumEnd: "",
      FilterAmountStart: "",
      FilterAmountEnd: "",
      FilterNAccType: 0,
      FilterBaseOrg: 0,
      FilterSearch: "",
      radioYear: "Year",
    };
  },
  props: ["LocationShow"],
  computed: {
    // دریافت سال جاری از مخزن
    getYearActive() {
      return this.$store.getters.getYearActive;
    },
    // دریافت لیست انواع سرفصل حساب
    getTbBaseDocTypeData() {
      // دریافت لیست انواع سرفصل حساب
      let typedata = this.$store.getters.getTbBaseDocTypeData;
      return typedata;
    },
    // دریافت لیست سازمان ها
    getTbBaseOrgData() {
      return this.$store.getters.getTbBaseOrgData;
    },
  },
  methods: {
    setLocationShow() {
      return "top: " + parseInt(this.LocationShow.top + 37) + "px;";
    },
    
    // لغو فیلتر لیست اسناد
    cancelFilter() {
      this.FilterDateStart = "";
      this.FilterDateEnd = "";
      this.FilterDocNumStart = "";
      this.FilterDocNumEnd = "";
      this.FilterAmountStart = "";
      this.FilterAmountEnd = "";
      this.FilterNAccType = 0;
      this.FilterBaseOrg = 0;
      this.FilterSearch = "";
      this.$emit("HideFilter", "");
    },

    // فیلتر لیست اسناد بر اساس مقادیر کاربر
    async filterListAcc() {
      if (
        this.FilterDateStart != "" ||
        this.FilterDateEnd != "" ||
        (this.FilterDocNumStart != "" && parseInt(this.FilterDocNumStart) != 0) ||
        (this.FilterDocNumEnd != "" && parseInt(this.FilterDocNumEnd) != 0) ||
        (this.FilterAmountStart != "" && parseInt(this.FilterAmountStart) != 0) ||
        (this.FilterAmountEnd != "" && parseInt(this.FilterAmountEnd) != 0) ||
        this.FilterNAccType != 0 ||
        this.FilterBaseOrg != 0 ||
        this.FilterSearch != ""
        ) {
          let userData = await this.$store.getters.getUserData;
          let token = userData.token;
          let nuserCode = userData.NUserCode;
        // آیا جستجو در تمام سالها انتخاب شده است ؟
        let yearActive = (this.radioYear != "AllYear" ? await this.$store.getters.getYearActive : 0);
        
        // فیلتر لیست اسناد سمت سرور
        var listResult = await this.$store.dispatch("FilterListDocToServer", {
          filterData: {
            NUserCode: nuserCode,
            NYear: yearActive,
            FilterDateStart: this.FilterDateStart,
            FilterDateEnd: this.FilterDateEnd,
            FilterDocNumStart: this.FilterDocNumStart,
            FilterDocNumEnd: this.FilterDocNumEnd,
            FilterAmountStart: this.FilterAmountStart,
            FilterAmountEnd: this.FilterAmountEnd,
            FilterNAccType: this.FilterNAccType.toString(),
            FilterBaseOrg: this.FilterBaseOrg.toString(),
            FilterSearch: this.FilterSearch,
          },
          token: token,
        });
        // آیا اطلاعاتی مشاهده شده است ؟
        if (listResult.length != 0) {
          this.$emit("HideFilter", listResult);
        } else {
          swal({
            title: "عدم مشاهده اطلاعات",
            text: "برای مقادیر درج شده اطلاعاتی مشاهده نشد !",
            icon: "warning", // success, warning, error, info
            buttons: {
              cancel: "متوجه شدم",
            },
          });
        }
      } else {
        swal({
          title: "عدم ثبت مقادیر",
          text: "درج یکی از مقادیر تاریخ ، شماره یا متن جستجو ، الزامی است !",
          icon: "warning", // success, warning, error, info
          buttons: {
            cancel: "متوجه شدم",
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.divFilter {
  position: absolute;
  left: 0px;
  width: 300px;
  background-color: #e6f2fd;
  min-height: 80px;
  z-index: 9999;
  padding: 5px;
  border-radius: 5px;
  box-shadow: rgb(0 0 0 / 40%) 0px 0px 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListDocInfo/Components/FilterListDocInfo.vue